import { defineMessages } from 'react-intl';
export default defineMessages({
  collectionDeleted: {
    id: 'component.collectionCard.collectionDeleted',
    defaultMessage: 'Collection deleted',
  },
});
